import type { IntestacyRuleSet } from "./types.js";

// NSW intestacy ruleset — Succession Act 2006 (NSW), Chapter 4.
//
// Distribution hierarchy (cited):
//   s111  — partner, no issue                  → partner takes the WHOLE estate.
//   s112  — partner + issue ALL of the partner → partner takes the WHOLE estate.
//   s113  — partner + issue NOT all the partner's ("blended family") →
//             partner takes: personal effects + the statutory legacy
//             (s106, CPI-indexed) + interest + ONE HALF of the remainder;
//             the issue take the other half equally.
//   s127+ — no partner: issue take all; else parents; else siblings; else
//             grandparents/aunts/uncles; else the State (bona vacantia).
//
// Statutory legacy (s106): base $350,000 from Dec 2005, CPI-indexed QUARTERLY,
// formula R = A × (C ÷ D). This REPRICES every quarter — each quarter is its own
// effective-dated period and a shipped value is NEVER mutated. Re-pull the
// current quarter's value before each quarterly rollover.
//
// Figures from the verification ledger (intestacy-checker-figures.md, fig 4/5,
// both CITED against the primary Act + nationalprobate.com.au, 2026-06-22):
//   30 Apr 2026 – 29 Jul 2026 : $611,387.84   (current)
//   30 Jan 2026 – 29 Apr 2026 : $603,091.72
//   30 Oct 2025 – 29 Jan 2026 : $599,761.34
//   30 Jul 2025 – 29 Oct 2025 : $591,825.78
export const nsw: IntestacyRuleSet = {
  state: "NSW",
  act: "Succession Act 2006 (NSW)",
  distributionRef: "Ch 4 ss 111–113, s 106",
  sources: {
    act: "https://classic.austlii.edu.au/au/legis/nsw/consol_act/sa2006138/",
    s106: "https://classic.austlii.edu.au/au/legis/nsw/consol_act/sa2006138/s106.html",
    s113: "https://classic.austlii.edu.au/au/legis/nsw/consol_act/sa2006138/s113.html",
    statutoryLegacy: "https://www.nationalprobate.com.au/nsw/statutory-legacy",
    plainEnglish:
      "https://www.nsw.gov.au/family-and-relationships/deaths/after-a-death/will-and-deceased-estate/dying-without-a-will",
  },
  sourcesVerifiedAt: "2026-06-22",
  statutoryLegacy: [
    {
      effectiveFrom: "2026-04-30",
      effectiveTo: "2026-07-29",
      amount: 611_387.84,
      source: "https://www.nationalprobate.com.au/nsw/statutory-legacy",
    },
    {
      effectiveFrom: "2026-01-30",
      effectiveTo: "2026-04-29",
      amount: 603_091.72,
      source: "https://www.nationalprobate.com.au/nsw/statutory-legacy",
    },
    {
      effectiveFrom: "2025-10-30",
      effectiveTo: "2026-01-29",
      amount: 599_761.34,
      source: "https://www.nationalprobate.com.au/nsw/statutory-legacy",
    },
    {
      effectiveFrom: "2025-07-30",
      effectiveTo: "2025-10-29",
      amount: 591_825.78,
      source: "https://www.nationalprobate.com.au/nsw/statutory-legacy",
    },
  ],
  // s113: partner takes one-half of the residue when issue are not all the partner's.
  partnerResidueShare: 0.5,
  partnerResidueShareOneChild: null,
  // s112: where all issue are the partner's, the partner takes the whole estate.
  partnerTakesAllWhenAllShared: true,
};
